const mEditionBillingArtificialIntelligenceUsage = {
  mEditionBillingArtificialIntelligenceUsage: {
    alerts: {
      readResumen: {
        error: 'Un error ha ocurrido al cargar el resumen de consumo. Vuelve a intentarlo en un momento.'
      },

      readVentas: {
        error: 'Un error ha ocurrido al cargar las ventas de IA. Vuelve a intentarlo en un momento.'
      }
    },

    charts: {
      byDaySubtitle: 'Costo real del proveedor, día por día, en dólares.',
      byDayTitle: 'Cuánto costó cada día',
      byModelSubtitle: 'De lo que más costó a lo que menos.',
      byModelTitle: 'Qué modelos se están usando',
      byTypeSubtitle: 'Preguntas, portadas e imágenes de pregunta, por costo.',
      byTypeTitle: 'En qué se va la plata',
      byWeekSubtitle: 'Costo real del proveedor, semana por semana, en dólares.',
      byWeekTitle: 'Cuánto costó cada semana',
      empty: 'No hay ninguna generación registrada en este rango.',
      others: 'Otros modelos',
      weekOf: 'semana del'
    },

    filters: {
      email: 'email o nombre del cliente',
      deletedAll: 'Eliminadas: incluirlas',
      deletedNo: 'Eliminadas: ocultarlas',
      modalityAll: 'Modalidad: todas',
      modalityCredits: 'Paquetes de créditos',
      modalityMonthly: 'Planes mensuales',
      rangeFrom: 'actividad desde',
      rangeTo: 'hasta',
      validAll: 'Vigencia: todas',
      validNo: 'No vigentes',
      validYes: 'Vigentes'
    },

    income: {
      cost: 'Costo del proveedor',
      empty: 'Ninguna de estas licencias tiene pagos acreditados todavía.',
      licenses: 'licencias',
      paid: 'Cobrado al cliente',
      payments: 'pagos acreditados',
      subtitle: 'De las licencias que estás viendo en esta página del listado.',
      title: 'Lo que pagan contra lo que cuesta'
    },

    labels: {
      generations: 'generaciones',
      never: 'Nunca',
      noName: 'Sin razón social',
      range: 'Actividad del',
      rangeTo: 'al',
      unlimited: 'Ilimitado'
    },

    messages: {
      noData: 'Todavía no hay ninguna licencia de IA vendida con estos filtros.',
      noDataHint: 'Probá quitando los filtros o incluyendo las licencias eliminadas.'
    },

    modalities: {
      creditos: 'Paquete de créditos',
      mensual: 'Plan mensual'
    },

    states: {
      activa: 'Activa',
      agotada: 'Agotada',
      eliminada: 'Eliminada',
      suspendida: 'Suspendida'
    },

    table: {
      thAccumulated: 'Consumo acumulado',
      thClient: 'Cliente',
      thCostUsd: 'Costo USD',
      thCredits: 'Créditos del plan',
      thCycle: 'Consumo del ciclo',
      thDate: 'Compra',
      thGenerations: 'Generaciones',
      thIncome: 'Ingreso',
      thPlan: 'Plan',
      thRecord: 'Ficha',
      thState: 'Estado'
    },

    tooltips: {
      failed: 'generaciones fallidas',
      record: 'Ver la ficha de consumo',
      reload: 'Limpiar filtros y recargar',
      sortAsc: 'Ordenar de menor a mayor',
      sortDesc: 'Ordenar de mayor a menor'
    },

    types: {
      imagen_pregunta: 'Imágenes de pregunta',
      portada: 'Portadas',
      preguntas: 'Preguntas'
    },

    totals: {
      amount: 'Preguntas e imágenes',
      costUsd: 'Costo del proveedor',
      credits: 'Créditos consumidos',
      creditsCharged: 'Créditos cobrados',
      failed: 'fallidas',
      generations: 'Generaciones',
      successful: 'exitosas',
      title: 'Todo lo que generó la IA en el rango'
    },

    warnings: {
      currencies: 'Dos monedas distintas',
      noCharge: 'El cobro está apagado: no se descuenta nada.',
      noRegistry: 'El registro está apagado: esto no se está guardando.',
      title: 'Ojo con lo que estás mirando'
    }
  }
}

export default mEditionBillingArtificialIntelligenceUsage
